import { render, staticRenderFns } from "./NoCampaigns.vue?vue&type=template&id=56ac78ad&scoped=true"
import script from "./NoCampaigns.vue?vue&type=script&lang=ts"
export * from "./NoCampaigns.vue?vue&type=script&lang=ts"
import style0 from "./NoCampaigns.vue?vue&type=style&index=0&id=56ac78ad&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac78ad",
  null
  
)

export default component.exports